/**
 * This function sums an array of numbers in the format <hours.minutes> comming from the BE
 * @param hoursMinutes an array in the <hours.minutes> format
 */
export function sumHoursMinutesFromBE(hoursMinutes: number[]): {
  hours: number;
  minutes: number;
} {
  const totalTime = hoursMinutes.reduce(
    (accumulator, currentValue) => {
      /** Due to the BE format is: <hours.minutes>, it is needed to split
       * the hours and the minutes and sum them in different accumulators
       * */
      const vTime = currentValue;
      const hours = Math.trunc(vTime);
      const minutes = Math.round((vTime - hours) * 100);
      return {
        hours: accumulator.hours + hours,
        minutes: accumulator.minutes + minutes,
      };
    },
    { hours: 0, minutes: 0 }
  );

  return {
    hours: Math.round(totalTime.hours + Math.trunc(totalTime.minutes / 60)),
    minutes: Math.round(totalTime.minutes % 60),
  };
}

/** 
 * Test for sumHoursMinutesFromBE function. Please do not remove.
export function testSumHoursMinutesFromBE() {
  function shouldReturn(
    hoursMinutes: { hours: number; minutes: number },
    hours: number,
    minutes: number,
    throwErrorText: string
  ) {
    if (hoursMinutes.hours === hours && hoursMinutes.minutes === minutes)
      return;
    throw new Error(throwErrorText);
  }
  let fakeData: number[], ret: { hours: number; minutes: number };

  fakeData = [];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 0, 0, 'Error []');

  fakeData = [0];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 0, 0, 'Error [0]');

  fakeData = [0.1, 0.2];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 0, 30, 'Error [0.1, 0.2]');

  fakeData = [0.1, 0.2, 0.3];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 1, 0, 'Error [0.1, 0.2, 0.3]');

  fakeData = [1];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 1, 0, 'Error [1]');

  fakeData = [1, 0];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 1, 0, 'Error [1, 0]');

  fakeData = [1.2];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 1, 20, 'Error [1.2]');

  fakeData = [2.1, 4.5, 3.1];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 10, 10, 'Error [2.1, 4.5, 3.1]');

  fakeData = [2.12, 4.53, 3.19, 3.45, 9.0, 3.56, 5.1];
  ret = sumHoursMinutesFromBE(fakeData);
  shouldReturn(ret, 32, 15, 'Error [2.12, 4.53, 3.19, 3.45, 9.0, 3.56, 5.1]');

  fakeData = [
    30.828507098009506, 65.76412201785922, 84.18715229281509, 41.99999999999999,
    3.566666666, 8.1111111111111111, 34.7999999999999,
  ];
  ret = sumHoursMinutesFromBE(fakeData);
  debugger;
  shouldReturn(
    ret,
    272,
    6,
    'Error [30.828507098009506, 65.76412201785922, 84.18715229281509, 41.99999999999999, 3.566666666, 8.1111111111111111, 34.7999999999999]'
  );
}
*/
